import { Notification, NotificationType } from './types'

export const putProfileFailNotification = {
  id: 'put-profile-fail',
  message: 'text.oops.error',
  type: 'error',
  notification: NotificationType.PUT_PROFILE_FAILED,
} as Notification
